import { useDispatch, useSelector } from 'react-redux';
import { selectIsShopifyUser } from '@mm/state/selectors/userSelector';
import { useEffect } from 'react';
import Actions from '@mm/state/actions/actions';
import { getIsShopifyApp, isShopifyRoute, setIsShopifyApp } from './helpers';

export const useShopifyEnv = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (getIsShopifyApp()) {
      setIsShopifyApp();

      window.MMApp = {
        loginUrl: 'https://admin.shopify.com',
        throwErrors: true,
      };

      dispatch({
        type: Actions.SET_APP_CONTEXT,
        payload: 'shopify',
      });
    }
  }, []);
};
